<template>
	<ion-header class="ion-no-border"> 
		<ion-toolbar class="flex flex-col">
			<div class="flex ion-justify-content-between ion-align-items-center w-full">
				<div class="flex ion-align-items-center">
					<ion-icon v-if="!backArrow" class="size-xxl" :icon="$icons.menu" @click="openMenu()" />
					<ion-icon v-else class="size-xxl" :icon="$icons.chevronBack" @click="goBack()" />
					<ion-icon v-if="addAction" class="size-xxl ml-1" :icon="$icons.addCircleOutline" @click="addAction()" />
				</div>

				<template v-if="!searchActive">
					<ion-segment v-if="!backArrow" class="<lg:hidden mx-auto my-0 w-1/2 h-[50px] max-w-[920px] rounded-none border-0 z-10 bg-primary" v-model="routePath" mode="md">
						<template v-for="{ route, name } in routes" :key="route">
							<ion-segment-button v-if="name != 'Unassigned tasks'" :value="route" class="[&:not(&.segment-button-checked)]:opacity-60" >
								<ion-label class="normal-case font-bold">{{name}}</ion-label>
							</ion-segment-button>
						</template>
					</ion-segment>
					<ion-title>{{title}}</ion-title>
				</template>

				<template v-if="hasSearch">
					<ion-icon v-if="!searchActive" class="size-xl" :icon="$icons.searchSharp" @click="showSearchbar(true)" />

					<p v-else class="button" @click="hideSearchbar()">Cancel</p>

					<ion-searchbar :value="modelValue" placeholder="Project or Task name..."
						:class="{'search-active' : searchActive}" :debounce="400" @ionChange="updateVModel" @keydown.esc="hideSearchbar()"
						@keyup.enter="enterPressed()" ref="searchbar" />
				</template>
			</div>
		</ion-toolbar>
	</ion-header>
</template>

<script>
import { menuController } from '@ionic/vue'
import { routes } from './a-menu-navigation'
import { mapGetters } from 'vuex'

import axios from '@/plugins/w/axios/models/axios'
const api = {
	getCapacityInfo: (userId, date) => axios.get_auth(`/report/proxy/users/${userId}/capacity?date=${date}`),
}

export default {
	props: {
		title: {
			type: String,
			default: 'Home'
		},

		modelValue: {
			type: String,
			default: ''
		},

		hasSearch: {
			type: Boolean,
			default: true
		},

		searchActive: {
			type: Boolean,
			default: true
		},

		backArrow: {
			type: Boolean,
			default: false
		},

		addAction: {
			type: Function
		}
	},

	emits: ['toggleSearch', 'enterPressed', 'update:modelValue'],

	data() {
		return {
			routes,
			isCapacityAlertShowing: false
		}
	},

	computed: {
		routePath: {
			set(route) {
				if (route == this.routePath)
					return
				this.$router.replace('/' + route)
			},
			get() {
				return this.$route.path.substring(1)
			}
		}
	},

	mounted() {
		for (var i = 1; this.searchActive && i <= 2; i++)
			setTimeout(this.focusSearch, i * 800)

		this.annoyUserWithCapacity()
	},

	methods: {
		...mapGetters('projectsStore', ['getUser']),

		openMenu() {
			menuController.open('app-menu')
		},

		focusSearch() {
			const input = this.$refs.searchbar.$el.querySelector('input')
			input.focus()
			return input
		},

		showSearchbar(emit) {
			if (emit)
				this.$emit('toggleSearch', true)

			this.focusSearch().select()
		},

		updateVModel(ev) {
			this.$emit('update:modelValue', ev.target.value)
		},

		hideSearchbar() {
			this.$emit('toggleSearch', false)
		},

		enterPressed() {
			this.$emit('enterPressed')
		},

		goBack() {
			this.$router.go(-1)
		},

		async annoyUserWithCapacity() {
			let now = new Date(),
				user = await this.getUser(),
				currentSet = localStorage.getItem('wzo_wgrid_capacity_lastnotice'),
				dateString = now.toISOString().slice(0, 10),
				showAfterDate = now,
				monthYear = now;

			let thisMonth = String(new Date().getMonth()),
				nextMonth = String((thisMonth+1)%12 + 1).padStart(2, '0');

			showAfterDate.setDate(14)
			monthYear.setDate(30)
			monthYear = monthYear.toISOString().slice(0, 7)+'-01'

			let hasShown = (
				currentSet == dateString || 
				currentSet == now.toISOString().slice(0, 7)+'-01' || 
				currentSet == `${(nextMonth == '01') ? new Date().getFullYear()+1 : new Date().getFullYear()}-${nextMonth}-01`
			)

			if (now < showAfterDate && !hasShown) {
				try {
					const capacity = await api.getCapacityInfo(user.userId, now.toISOString().slice(0, 7)+'-01')
				} catch (e) {
					console.log(e)
					if (e.response.data.error == 'UserMonthStamp not found') {
						this.$toast.custom({
							message: `CAPACITY IS NOT SET! No capacity set for ${now.toISOString().slice(0, 7).replace('-', '/')}`,
							duration: 10000,
							position: 'top',
							buttons: [
								{
									text: 'Set Capacity',
									handler: () => this.$router.push({ name: 'capacity' })
								}
							]
						})

						localStorage.setItem('wzo_wgrid_capacity_lastnotice', now.toISOString().slice(0, 7)+'-01')
					}
				}
			} else if (!hasShown) {
				let month = `${(nextMonth == '01') ? new Date().getFullYear()+1 : new Date().getFullYear()}-${nextMonth}-01`
				try {
					const capacity = await api.getCapacityInfo(user.userId, month)
				} catch (e) {
					console.log(e)
					if (e.response.data.error == 'UserMonthStamp not found') {
						this.$toast.show({
							message: `CAPACITY IS NOT SET! No capacity set for ${now.toISOString().slice(0, 7).replace('-', '/')}`,
							duration: 10000,
							position: 'top',
							buttons: [
								{
									text: 'Set Capacity',
									handler: () => this.$router.push({ name: 'capacity' })
								}
							]
						})

						localStorage.setItem('wzo_wgrid_capacity_lastnotice', month)
					}
				}
			}
		
			
		}
	}
}
</script>

<style lang="sass" scoped>
[theme="dark"]
	ion-segment-button
		--color-checked: white

ion-header
	ion-toolbar
		--background: var(--ion-color-primary) !important
		--min-height: 50px
		--padding-start: 15px
		--padding-end: 15px

		ion-segment-button
			--color: white
			--color-checked: var(--ion-color-primary)

			--border-radius: 0 !important
			--indicator-height: 50px !important
			--background-checked: var(--ion-background-color)
			--indicator-color: transparent 

			--ripple-color: transparent
			--background-hover: transparent

		ion-title, p, ion-icon
			color: white

		p
			cursor: pointer

		ion-icon
			cursor: pointer

			&:before
				content: ''
				position: absolute
				width: 100%
				height: 100%

ion-searchbar
	position: absolute
	top: calc( 50% - 18px )
	right: 70px
	width: 0
	height: 36px
	z-index: 99 !important
	margin: 0
	padding: 0
	overflow: hidden
	--background: var(--ion-color-light)
	--border-radius: 3px
	transition: .24s

	&::v-deep
		.searchbar-input
			font-size: 13px !important

	&.search-active
		width: calc( 100% - 85px ) !important
		
</style>